(function () {
  var buttonSelector = '[data-normal-checkout]';

  function getErrorContainer(button, form) {
    return (
      form.querySelector('.productErrors') ||
      button.closest('.shopify-section')?.querySelector('.productErrors') ||
      button.closest('.quick-add-popup')?.querySelector('.productErrors')
    );
  }

  function showError(container, message) {
    if (!container) {
      return;
    }

    container.textContent = message;
    container.style.display = 'block';
  }

  function clearError(container) {
    if (!container) {
      return;
    }

    container.textContent = '';
    container.style.display = 'none';
  }

  function setLoading(button, loading) {
    button.classList.toggle('is-loading', loading);
    button.toggleAttribute('disabled', loading);
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function dispatchCheckoutEvent(name, detail) {
    document.dispatchEvent(
      new CustomEvent('normal-checkout:' + name, {
        detail: detail
      })
    );
  }

  function syncButtonState(form) {
    if (!form) {
      return;
    }

    var button = form.querySelector(buttonSelector);
    if (!button || button.classList.contains('is-loading')) {
      return;
    }

    var variantInput = form.querySelector('input[name="id"]');
    var addToCartButton = form.querySelector('.Sd_addProduct');
    var termsCheckbox = form.querySelector('input[name="terms_conditions"]');
    var disabled =
      !variantInput ||
      !variantInput.value ||
      (addToCartButton && addToCartButton.disabled) ||
      (termsCheckbox && !termsCheckbox.checked);

    button.toggleAttribute('disabled', Boolean(disabled));
  }

  async function checkout(button) {
    var form = button.closest('form[action*="/cart/add"]');
    if (!form || button.disabled || button.classList.contains('is-loading')) {
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var variantInput = form.querySelector('input[name="id"]');
    var variantId = variantInput && variantInput.value ? variantInput.value.trim() : '';
    var errorContainer = getErrorContainer(button, form);

    if (!variantId) {
      showError(errorContainer, 'Please select an available product option.');
      return;
    }

    var formData = new FormData(form);
    formData.set('id', variantId);
    if (!formData.has('quantity')) {
      formData.set('quantity', '1');
    }

    clearError(errorContainer);
    setLoading(button, true);
    dispatchCheckoutEvent('start', { button: button, form: form });

    try {
      var root = window.Shopify?.routes?.root || '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      var result = await response.json().catch(function () {
        return {};
      });

      if (!response.ok) {
        throw new Error(result.description || result.message || 'Unable to add this item to your cart.');
      }

      dispatchCheckoutEvent('success', { button: button, form: form });
      window.location.assign(root + 'checkout');
    } catch (error) {
      var message = error.message || 'Unable to proceed to checkout.';
      showError(errorContainer, message);
      setLoading(button, false);
      syncButtonState(form);
      dispatchCheckoutEvent('error', {
        button: button,
        form: form,
        message: message,
        error: error
      });
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(buttonSelector);
    if (!button) {
      return;
    }

    event.preventDefault();
    checkout(button);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('input[name="id"], input[name="terms_conditions"]')) {
      return;
    }

    var form = event.target.closest('form[action*="/cart/add"]');
    window.setTimeout(function () {
      syncButtonState(form);
    }, 0);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(syncButtonState);
  });
})();
